import type { Product, ProductCardExtended } from '#root/api/clients/product/data-contracts'

export const useCompareStore = defineStore('compare', () => {
  const compareItems = ref<(Product | ProductCardExtended)[]>([])

  const addCompareItem = (product) => {
    if (compareItems.value.length >= 4) return
    if (compareItems.value.some((item) => item.styleId === product.styleId)) return
    compareItems.value = [...compareItems.value, product]
  }

  const removeCompareItem = (styleId) => {
    compareItems.value = compareItems.value.filter(
      (item) => item.styleId !== styleId
    )
  }

  const cancel = () => compareItems.value = []

  return {
    addCompareItem,
    cancel,
    compareItems,
    removeCompareItem
  }
})
